export const SortByReviews = [
  {
    name: 'Most Recent',
    value: 'createdOn'
  },
  {
    name: 'Most Helpful',
    value: 'likeCount'
  }
];
